import {Component, OnInit, DoCheck, Input, EventEmitter, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgSelectModule} from '@ng-select/ng-select';
import {PlanModel} from '../../common/service/plan-model.model';
import {FieldRecordPurpose, FormerTenureSubjectOfPlans} from '../lodge-field-record.model';
import {isValidNumber, isValidString} from '../../common/service/data-util';

@Component({
    selector: 'nlr-plan-field-record-details',
    imports: [FormsModule, CommonModule, NgSelectModule],
    templateUrl: './field-record-details.component.html',
    styleUrl: './field-record-details.component.scss'
})
export class FieldRecordDetailsComponent implements OnInit, DoCheck {
    selectedCategory = undefined;
    selectedPurpose = undefined;
    planModel: PlanModel = undefined;
    submitted = false;
    categoryActiveRow: number = 0;

    @Input()
    model: PlanModel;
    @Input()
    fieldRecordPurposes: FieldRecordPurpose[];
    @Input()
    formerTenureSubjectOfPlans: FormerTenureSubjectOfPlans[];

    @Output()
    modelChanged = new EventEmitter<PlanModel>();

    @Output()
    validationChanged = new EventEmitter<boolean>();

    categories = [];
    previousPurpose = '';

    constructor() {}

    ngOnInit(): void {
        this.model.category = this.model.category === '' ? undefined : this.model.category;

        if (this.fieldRecordPurposes) {
            this.categories = this.fieldRecordPurposes
                .reduce(function (acc, purpose) {
                    if (acc.indexOf(purpose.category) === -1) {
                        acc.push(purpose.category);
                    }
                    return acc;
                }, [])
                .sort();
        }

        if (this.model.purpose) {
            const modelPurpose = this.model.purpose;
            const purpose = this.fieldRecordPurposes.filter(function (v) {
                return v.id === modelPurpose;
            })[0];
            this.selectedPurpose = purpose;
            this.selectedCategory = purpose.category;
            this.model.category = purpose.category;
        }
    }

    ngDoCheck(): void {
        if (this.model) {
            const modelPurpose = this.model.purpose;
            if (this.previousPurpose !== modelPurpose) {
                this.previousPurpose = modelPurpose;
                if (this.fieldRecordPurposes) {
                    const selectedPurpose = this.fieldRecordPurposes.filter(function (v) {
                        return v.id === modelPurpose;
                    })[0];
                    if (selectedPurpose) {
                        const selectedPurposeSubjectOfPlanCodes = (selectedPurpose.subjectOfPlans || '').split(',');
                        const selectedPurposeSubjectOfPlans = this.formerTenureSubjectOfPlans.filter(function (v) {
                            return selectedPurposeSubjectOfPlanCodes.indexOf(v.id) !== -1;
                        });
                        if (selectedPurposeSubjectOfPlans.length === 1) {
                            this.model.formerTenureSubjectOfPlan = selectedPurposeSubjectOfPlans[0].id;
                            return;
                        }
                    }
                    if (this.model.formerTenureSubjectOfPlan) {
                        delete this.model.formerTenureSubjectOfPlan;
                    }
                }
            }
        }
    }

    isCategoryValid() {
        return !(this.model.category === undefined || this.model.category === '');
    }

    isPurposeValid() {
        return !(this.model.purpose === undefined || this.model.purpose === null || this.model.purpose === '');
    }

    updateSelectedCategory(option: string): void {
        this.selectedCategory = option;
        this.model.category = this.selectedCategory;
        this.model.purpose = null;
        this.selectedPurpose = null;
        if (this.model.category) this.validationChanged.emit(this.validate());
    }

    updateSelectedPurpose(option: FieldRecordPurpose): void {
        this.selectedPurpose = option;
        this.model.purpose = option.id;
        if (this.model.purpose) this.validationChanged.emit(this.validate());
    }

    onInputChange(newValue: number) {
        this.model.fieldRecordNumber = newValue;
        if (this.model.fieldRecordNumber) this.validationChanged.emit(this.validate());
    }

    filterPurposes() {
        return this.fieldRecordPurposes
            .filter(v => {
                return v.category === this.model.category;
            })
            .sort((a, b) => a.uiOptionOrder - b.uiOptionOrder);
    }

    purposeTrackBy(item) {
        return item.id;
    }

    validate(){
        return isValidNumber(this.model.fieldRecordNumber) && isValidString(this.model.category) &&  isValidString(this.model.purpose);
    }
}
